export const reportType = {
  DOCX: 'docx',
  XLSX: 'xlsx',
  CHART: 'chart',
}



// WEBPACK FOOTER //
// ./src/constants/generateFile.js